import React, {Component} from 'react';

import * as MaskFunctions from '@chocostack/maskifier';
import {
    CCText,
    Image,
    TouchableWithoutFeedback,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import Styles from "../../../Styles";
import {GetTextColor, GetTextColorAlt, HexToRGBA} from "../../../ColorFunctions";

import ImageModal from "../../../custom-packages/image-modal/ImageModal";

export default class PublicMenuItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item,
            deleted: false,
            isImageModalOpen: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const oldConfig = this.props.config;
        const newConfig = nextProps.config;
        
        return nextProps.item.name != this.props.item.name
            ||
            nextProps.item.description != this.props.item.description
            ||
            nextProps.item.title != this.props.item.title
            ||
            nextState.isImageModalOpen != this.state.isImageModalOpen
            ||
            !(
                oldConfig.logo === newConfig.logo &&
                oldConfig.name === newConfig.name &&
                oldConfig.primaryColor === newConfig.primaryColor &&
                oldConfig.backgroundColor === newConfig.backgroundColor &&
                oldConfig.fontFamily === newConfig.fontFamily &&
                oldConfig.textAlign === newConfig.textAlign &&
                oldConfig.cardBackgroundColor === newConfig.cardBackgroundColor &&
                oldConfig.cardBorderWidth === newConfig.cardBorderWidth &&
                oldConfig.cardBorderColor === newConfig.cardBorderColor &&
                oldConfig.cardBorderRadius === newConfig.cardBorderRadius &&
                oldConfig.cardOpacity === newConfig.cardOpacity &&
                oldConfig.cardShadowIntensity === newConfig.cardShadowIntensity
            );
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    cleanString(input) {
        const tildeMap = {
            'á': 'a', 'Á': 'A',
            'é': 'e', 'É': 'E',
            'í': 'i', 'Í': 'I',
            'ó': 'o', 'Ó': 'O',
            'ú': 'u', 'Ú': 'U',
            'ñ': 'n', 'Ñ': 'N',
        };

        return input
            .replace(/./g, (char) => tildeMap[char] || char) // Replace letters with a tilde
            .replace(/[^\w\s]|_/g, '') // Remove special characters and underscore
            .replace(/\s+/g, ''); // Remove whitespaces
    }

    render() {
        if (this.state.deleted) {
            return null;
        }

        let sectionTitleStyles = {}
        let cardStyles = {}


        let boxShadow = 'none';

        if (this.props.config.cardShadowIntensity == 1)
            boxShadow = '0 2px 3px 0 rgba(0, 0, 0, 0.1)'
        else if (this.props.config.cardShadowIntensity == 2)
            boxShadow = '0 3px 5px 0 rgba(0, 0, 0, 0.2)'
        else if (this.props.config.cardShadowIntensity == 3)
            boxShadow = '0 4px 7px 0 rgba(0, 0, 0, 0.3)'
        else if (this.props.config.cardShadowIntensity == 4)
            boxShadow = '0 5px 9px 0 rgba(0, 0, 0, 0.4)'
        else if (this.props.config.cardShadowIntensity == 5)
            boxShadow = '0 6px 11px 0 rgba(0, 0, 0, 0.5)'

        cardStyles = {
            backgroundColor: HexToRGBA(this.props.config.cardBackgroundColor, this.props.config.cardOpacity),
            border: this.props.config.cardBorderWidth > 0 ?
                this.props.config.cardBorderWidth + 'px solid ' + HexToRGBA(this.props.config.cardBorderColor, this.props.config.cardOpacity)
                :
                "none",
            borderRadius: this.props.config.cardBorderRadius,
            boxShadow: boxShadow
        }

        const {registerSectionRef} = this.props;

        return <View>
            {this.props.item.title ?
                <div
                    ref={(ref) =>
                        registerSectionRef(this.props.item.sectionId, ref)
                    }
                >
                    <View
                        id={this.props.item.title}
                    >
                        <CCText style={{
                            textAlign: this.props.config.textAlign,
                            marginTop: 15,
                            padding: '10px 10px 0',
                            fontSize: 28,
                            fontWeight: 'bold',
                            color: this.props.config.primaryColor === this.props.config.backgroundColor ? GetTextColor(this.props.config.primaryColor) : this.props.config.primaryColor,
                            ...sectionTitleStyles
                        }}>
                            {this.props.item.title}
                        </CCText>
                        <CCText style={{
                            padding: '0 10px 25px',
                        }}>
                            {this.props.item.sectionDescription}
                        </CCText>
                    </View>
                </div>
                :
                null
            }
            <div
                style={{marginBottom: 15, padding: 0}}
            >
                <div
                    className={'menu-item-card'}
                    style={cardStyles}
                >
                    <View>
                        <View className={'menu-item-body'}>
                            <View>
                                <h4 className={'menu-item-name'} style={{
                                    color: GetTextColorAlt(
                                        this.props.config.backgroundColor,
                                        this.props.config.cardBackgroundColor,
                                        this.props.config.cardOpacity
                                    ),
                                    textAlign: this.props.config.textAlign
                                }}>
                                    {this.props.item.name}
                                </h4>
                                {
                                    this.props.item.prices.length == 1 ?
                                        <div
                                            className={'menu-item-price'}
                                            style={{
                                                color: GetTextColorAlt(
                                                    this.props.config.backgroundColor,
                                                    this.props.config.cardBackgroundColor,
                                                    this.props.config.cardOpacity
                                                ) === 'white' ? 'white' : '',
                                                textAlign: this.props.config.textAlign
                                            }}
                                        >
                                            {MaskFunctions.maskMoney(this.props.item.prices[0].price) + ' ' + this.props.item.prices[0].currency}
                                        </div>
                                        :
                                        <View
                                            style={{margin: 10}}
                                        >
                                            {
                                                this.props.item.prices.map(p => <View
                                                    style={{
                                                        flexDirection: 'row',
                                                        justifyContent: this.props.config.textAlign === 'center' ? 'center' :
                                                            this.props.config.textAlign === 'left' ? 'flex-start' :
                                                            this.props.config.textAlign === 'right' ? 'flex-end' : ''
                                                    }}
                                                    className={'menu-item-price-list'}
                                                >
                                                    <div className={'menu-item-price-name'} style={{
                                                        marginRight: 7,
                                                        color: GetTextColorAlt(
                                                            this.props.config.backgroundColor,
                                                            this.props.config.cardBackgroundColor,
                                                            this.props.config.cardOpacity
                                                        )
                                                    }}>
                                                        {p.title}:
                                                    </div>
                                                    <div className={'menu-item-price'}
                                                         style={
                                                             GetTextColorAlt(
                                                                 this.props.config.backgroundColor,
                                                                 this.props.config.cardBackgroundColor,
                                                                 this.props.config.cardOpacity
                                                             ) === 'white' ? {color: 'white'} : {}
                                                         }>
                                                        {MaskFunctions.maskMoney(p.price) + ' ' + p.currency}
                                                    </div>
                                                </View>)
                                            }
                                        </View>
                                }
                                {this.props.item.description ?
                                    <div
                                        className={'menu-item-description'}
                                        style={{
                                            color: GetTextColorAlt(
                                                this.props.config.backgroundColor,
                                                this.props.config.cardBackgroundColor,
                                                this.props.config.cardOpacity
                                            ) === 'white' ? 'white' : '',
                                            textAlign: this.props.config.textAlign
                                        }}
                                    >
                                        {this.props.item.description}
                                    </div>
                                    :
                                    null
                                }
                            </View>
                        </View>
                        {this.props.item.image_lq ?
                            <View>
                                <TouchableWithoutFeedback
                                    onPress={() => {
                                        this.setState({isImageModalOpen: !this.state.isImageModalOpen})
                                    }}
                                >
                                    <Image source={{uri: this.props.item.image_lq}}/>
                                </TouchableWithoutFeedback>
                                <ImageModal
                                    visible={this.state.isImageModalOpen}
                                    onRequestClose={() => {
                                        this.setState({isImageModalOpen: !this.state.isImageModalOpen})
                                    }}
                                    image={this.props.item.image}
                                />
                            </View>
                            :
                            null
                        }
                    </View>
                </div>
            </div>
        </View>;
    }
}